import React, { useState, useEffect } from 'react';
import { Checkbox, Button } from '@jcm/design-system';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import styles from './ModalConfirmacao.module.scss';
import ModalContainer from '../../../components/modalContainer/ModalContainer';

interface ModalConfirmacaoProps {
	visivel: boolean;
	onConfirm: () => void;
	onCancel: () => void;
	titulo: string;
	descricao: string | React.ReactNode;
	confirmButtonText: string;
	cancelButtonText?: string;
	isDanger?: boolean;
	confirmButtonDisabled?: boolean;
	cancelButtonDisabled?: boolean; 
	hideCheckbox?: boolean;
	customCheckboxLabel?: string;
}

const ModalConfirmacao: React.FC<ModalConfirmacaoProps> = ({
	visivel,
	onConfirm,
	onCancel,
	titulo,
	descricao,
	confirmButtonText,
	cancelButtonText = 'Cancelar',
	isDanger = false,
	confirmButtonDisabled,
	cancelButtonDisabled = false, 
	hideCheckbox,
	customCheckboxLabel,
}) => {
	const [checkConfirmado, setCheckConfirmado] = useState(false);
	const checkboxId = React.useId();

	useEffect(() => {
		if (visivel) {
			setCheckConfirmado(false);
		}
	}, [visivel]);

	const handleCheckboxChange = (e: { target: { checked: boolean } }) => {
		setCheckConfirmado(e.target.checked);
	};

	return (
		<ModalContainer
			isVisible={visivel}
			onClose={onCancel}
			className={styles.modalConfirmacao}
			fechamentoPermitido={true}
		>
			<div className={styles.header}>
				<ExclamationCircleOutlined className={styles.iconAttention} />
				<h2>{titulo}</h2>
			</div>

			<div className={styles.modalContent}>
				<p>{descricao}</p>
				{!hideCheckbox && (
					<div className='checkboxContainer' style={{ marginTop: '1rem' }}>
						<Checkbox id={checkboxId} checked={checkConfirmado} onChange={handleCheckboxChange}>
							{customCheckboxLabel || 'Sim, desejo continuar.'}
						</Checkbox>
					</div>
				)}
			</div>

			<div className={styles.footer}>
				<Button 
					onClick={onCancel} 
					variant='error' 
					type='outlined' 
					className='error' 
					disabled={cancelButtonDisabled} 
				>
					{cancelButtonText}
				</Button>
				<Button
					onClick={onConfirm}
					disabled={!checkConfirmado || confirmButtonDisabled}
					variant={isDanger ? 'error' : 'default'}
					type='filled-tonal'
					className='default'
				>
					{confirmButtonText}
				</Button>
			</div>
		</ModalContainer>
	);
};

export default ModalConfirmacao;